// @flow
export {
  default,
} from 'web-ssr/app/app-directory/components/AppIntegrationPromo/Container';
